import { useEffect, useState } from "react"

import { useEventBus } from "@cirrus/core/events"
import { useTranslations } from "@cirrus/core/i18n"

import { IProctorioObserverEvent } from "../event"

export const useProctorioObserverCdnLoader = ({ useProctorio }: IProps) => {
  const [observeReady, setObserveReady] = useState(false)
  const bus = useEventBus<IProctorioObserverEvent>()
  const { i18n } = useTranslations()

  useEffect(() => {
    if (!useProctorio) return

    const existingScript = document.getElementById(PROCTORIO_OBSERVE_SCRIPT_ID) as HTMLScriptElement | null

    if (window.Observe?.Observe) {
      setObserveReady(true)
      return
    }

    const handleLoad = () => {
      if (window.Observe?.Observe) setObserveReady(true)
    }

    if (existingScript) {
      existingScript.addEventListener("load", handleLoad)

      return () => {
        existingScript.removeEventListener("load", handleLoad)
      }
    }

    const script = document.createElement("script")
    script.id = PROCTORIO_OBSERVE_SCRIPT_ID
    script.src = "/static/observe/index.1.0.8.min.js"
    script.integrity = "sha384-UAh87fK9VkOH/lMlV0LZcBOrt2Ocdr/358gA5xz4uaAw0AH0bMkQpYNuIjkZzRbZ"
    script.crossOrigin = "anonymous"
    script.async = true

    script.onload = handleLoad

    script.onerror = () => {
      bus.emit("ProctorioObserver > Dialog > Open", {
        content: i18n("Delivery.ProctorioObserver:FailureInitializingMessage")
      })
    }

    document.head.appendChild(script)

    return () => {
      script.onload = null
      script.onerror = null
    }
  }, [useProctorio])

  return {
    observeReady
  }
}

const PROCTORIO_OBSERVE_SCRIPT_ID = "proctorio-observe-sdk"

interface IProps {
  useProctorio: boolean
}
